<template>
    <section class="content" style="position: relative;">
        <div :class="addButtonClass" class="common_save_btn">
            <router-link :to="{ name: 'vehiclesCreate', params: { _id: '0' } }">
                <button class=" btn gradientbt">+ Add Vehicle</button>
            </router-link>
        </div>

        <div class="main_select_wrp_relative main_select_wrp_vechile">
            <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document" style="width: 50%">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>Filters</h2>
                            <button type="button" class="close clearButton" data-dismiss="modal"
                                v-on:click="clearFilter">Clear All</button>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="main_select_wrp">
                                <div class="flex selectwca_wrp">
                                    <div class="multiselected">
                                        <multiselect track-by="value" v-model="clearFilters.city.value" label="name"
                                            placeholder="Select City" :options="areas" name="areas" selectLabel=""
                                            deselectLabel="" selectedLabel="" @select="onChecked" @remove="onRemove">
                                        </multiselect>
                                    </div>
                                    <!-- <div class="multiselected">
                                        <multiselect track-by="value" v-model="clearFilters.vehicle.value" label="name" placeholder="Select Vehicle" :options="vehicles" multiple name="vehicle" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedVT" @remove="onRemoveVT"></multiselect>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="datedrop_boxs_wrapper">
            <div class="datedrop_boxs_inner datedrop_boxs_inner_survey">

                <div :class="addButtonClass">
                    <div class="filter_wrpp filter_wrpp1" v-if="this.checkRole == 'Super Admin'">
                        <button type="button" class="btn" data-toggle="modal" data-target="#filtertoogle">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                                <g transform="translate(0 -1028.4)">
                                    <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                                    <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                                    <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                                    <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                                </g>
                            </svg> -->
                            <img src="../../../../static/img/pri_filter_icon.png">
                            Apply Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="box-body">


                <v-server-table ref="vehiclesTable" url :limit="5" :columns="columns" :options="options"
                    @loaded="onLoaded">
                    <template slot="beforeBody">
                        <tr v-if="loading" class="VueTables__no-results">
                            <td class="text-center" colspan="6">
                                <pulse-loader></pulse-loader>
                            </td>
                        </tr>
                    </template>
                    <template slot="status" slot-scope="props">
                        <div class="active_wrp">
                            <div class="py-2 text-center row">
                                <label class="toggle">
                                    <input class="toggle-checkbox" type="checkbox" :checked="props.row.status"
                                        @click.prevent="(e) => activateVehicleModal(props.row)" />
                                    <span class="slider"></span>
                                    <!-- <span class="labels" data-on="Active" data-off="Deactivate"></span> -->
                                </label>
                            </div>

                        </div>
                    </template>

                    <template slot="action" slot-scope="props">
                        <div class="active_wrp">
                            <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                            <a class="fa fa-map-marker"
                                :href="'https://tracker.mussoorie.hashstudioz.com/vehicles/?token=SDBGAiEA5_T3tZaXZ2ynF92N2uRLu1LoXhQkZEMBPwMW9kCT-NkCIQDYfRCzqmC57oDvLC6uTAxyNjkKcCz_xAlJBQKQ06h92nsidSI6NiwiZSI6IjIwMjgtMDEtMjRUMTg6MzA6MDAuMDAwKzAwOjAwIn0'"
                                :target="'_blank'"></a>
                        </div>


                    </template>

                </v-server-table>
            </div>
        </div>
    </section>
</template>

<script>
import {
    eventBus,
    vehiclesService
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";
import {
    Multiselect
} from "vue-multiselect";
import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";

export default {
    name: "vehicles",
    components: {
        Multiselect,
    },
    data() {
        return {
            params: {},
            checkRole: "",
            loading: null,
            count: null,
            cityFilterCount: 0,
            count1: null,
            activeInactiveStatus: 0,
            USER_ROLES: USER_ROLES,
            vehiclesTable: null,
            checkedRoles: [],
            tableCount: "",
            checkedVehicle: [],
            clearFilters: {
                vehicle: "",
                city: "",
                status: "",
            },
            filters: {},
            areas: [],
            vehicles: [{
                name: "Primary(Small)",
                value: "Primary(Small)"
            },
            {
                name: "Secondary(Large)",
                value: "Secondary(Large)"
            },
            ],
            status: [{
                name: "Active",
                value: true
            },
            {
                name: "Inactive",
                value: false
            },
            ],
            checkedCities: [],
            columns: ["vNumber", "vModelName", "assignGpsId", "action"],

            options: {
                highlightMatches: true,
                headings: {
                    cityName: "City",
                    vNumber: "Vehicle Number",
                    vModelName: "Model Name",
                    assignGpsId: "GPS Id",
                    actions: "Action",
                },
                templates: {},
                perPage: 10,
                sortable: ["cityName", "vNumber", "vModelName", "assignGpsId", "status"],
                requestFunction: (request) => {
                    this.params.page = request.page;
                    this.params.limit = request.limit;
                    if (request.orderBy) {
                        if (request.orderBy == "cityName") {
                            this.params.sortBy = "cityId.cityName"
                        } else {
                            this.params.sortBy = request.orderBy;
                        }
                    }

                    if (request.ascending == 1) {
                        this.params.sortOrder = "asc";
                    } else {
                        this.params.sortOrder = "des";
                    }
                    if (request.query.status) {
                        this.params.status = request.query.status;
                    }

                    if (request.query) {
                        this.params.searchString = request.query;
                    } else {
                        this.params.searchString = '';
                    }
                    if (this.count === 0 && this.count1 === 0) {
                        this.count = null;
                        this.count1 = null;
                    }
                    this.loading = true;
                    return this.$vehicleDataRepository
                        .collectionVehiclesList(this.params, this.filters)
                        .catch((error) => { });
                },

                responseAdapter: (response) => {
                    this.loading = false;

                    let dataResponse = [];
                    let count;
                    response.data.response.forEach((element) => {
                        var dataVehicles = element;
                        dataVehicles["cityName"] = element.cityId ? element.cityId.cityName : null;
                        dataVehicles["vModelName"] = element.vModelName ? element.vModelName : '--';
                        dataVehicles["assignGpsId"] = element.assignGpsId ? element.assignGpsId : '--'
                        dataResponse.push(dataVehicles);
                    });
                    if (dataResponse.length === 0) {
                        count = 0;
                    }
                    return {
                        data: dataResponse,
                        count: response.data.total || count,
                    };
                },

                customFilters: [{
                    name: "custom_filter",
                    callback: function (row, query) {
                        //	return row.role[0] == query;
                    },
                },],
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.vehiclesTable) {
                this.tableCount = this.vehiclesTable.count
                return this.vehiclesTable.count > this.vehiclesTable.limit ||
                    this.vehiclesTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        clearFilter() {
            this.clearFilters = {
                vehicle: "",
                status: "",
            };
            this.count = null;
            this.count1 = null;
            this.cityFilterCount = 0;
            this.activeInactiveStatus = 0;
            delete this.params.status;
            delete this.params["vehicleType"];
            this.$refs.vehiclesTable.refresh();
        },
        activateVehicleModal(row) {
            let confirmtext;
            if (row.status === true) {
                confirmtext = "Deactivate";
            } else {
                confirmtext = "Activate";
            }
            swal({
                title: `Are you sure you want to ${confirmtext} it?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#35A2FE",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${confirmtext}`,
            }).then((result) => {
                if (result.value) {
                    this.activateVehicle(row);
                } else {
                    swal.close();
                }
            });
        },
        activateVehicle(row) {
            let status1;
            let confirmtext;
            if (row.status === true) {
                confirmtext = "Deactivate";
                status1 = false;
            } else {
                confirmtext = "Activate";
                status1 = true;
            }
            const id = row._id;
            let vehicle = {
                _id: row._id,
                vNumber: row.vNumber,
                vMakeYear: row.vMakeYear,
                vModelName: row.vModelName,
                assignGpsId: row.assignGpsId,
                status: status1,
                cityId: row.cityId._id,
            };
            this.loading = true;
            return vehiclesService
                .updateVehicle(id, vehicle)
                .then((response) => {
                    this.loading = false;
                    row.status = !row.status;
                    this.$snotify.success(
                        `The ${row.vNumber} has been marked ${confirmtext}.`
                    );
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(`${error.data.message}`);
                });
        },

        action(row) {
            this.$router.push({
                name: "vehiclesCreate",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },

        onLoaded() {
            this.vehiclesTable = this.$refs.vehiclesTable;
        },
        applyFilter(filter_val) {
            Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
        },

        onChecked(option) {
            // if(this.cityFilterCount === 0){
            //   this.count1 === 0 || this.count1 === null ? this.count = 1 : this.count += this.count1;
            //   this.cityFilterCount = 1;
            // }
            let id = option.value;
            this.params.cityId = id;
            if (this.$refs.vehiclesTable) {
                this.$refs.vehiclesTable.refresh();
            }
        },
        onSelectStatus(option) {
            if (this.activeInactiveStatus === 0) {
                this.activeInactiveStatus = 1;
                this.count += 1;
                this.count1 += 1;
            }
            if (this.$route.params.status === 'Active') {
                const option = {
                    name: 'Acive',
                    value: [{
                        name: 'Active',
                        value: true
                    }]
                };
                this.clearFilters.status = option;
                this.params.status = true;
            } else {
                this.clearFilters.status = option;
                this.params.status = option.value;
                this.$refs.vehiclesTable.refresh();
            }
        },
        onRemoveStatus() {
            this.activeInactiveStatus = 0;
            this.count -= 1;
            this.count1 -= 1;
            this.clearFilters.status = "";
            this.params.status = "";
            this.$refs.vehiclesTable.refresh();
        },
        onCheckedVT(option) {
            this.clearFilters.vehicle = option;
            let id = option.value;
            this.checkedVehicle.push(id);
            this.vehicleTypeFunc(this.checkedVehicle);
            this.$refs.vehiclesTable.refresh();
        },
        onRemoveVT(option) {
            let id = option.value;
            this.checkedVehicle = this.checkedVehicle.filter(
                (elemant) => elemant != id
            );

            this.params["vehicleType"] = this.checkedVehicle;
            this.$refs.vehiclesTable.refresh();
        },
        vehicleTypeFunc(vehicleType) {
            this.params["vehicleType"] = vehicleType.reduce(
                (accumulator, currentValue) => {
                    if (accumulator) {
                        return `${accumulator},${currentValue}`;
                    } else {
                        return currentValue;
                    }
                },
                ""
            );
            this.$refs.vehiclesTable.refresh();
        },
    },
    mounted() {
        this.params.cityId = this.$store.state.auth.cityId.value
        eventBus.$on('cityIdChanged', this.onChecked);
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("cityName");
        }
        eventBus.$on("DATA_PUBLISHED", (payload) => { });
        this.checkRole = this.$store.state.auth.user.role.name;
    },
    beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onChecked);
    },
    created() {
        this.clearFilters = {
            ...this.clearFilters,
            city: {
                ...this.clearFilters.city,
                value: this.$route.params.cityIds
            }
        }

        if (this.$route.params.cityIds && this.$route.params.cityIds.value) {
            this.params.cityId = this.clearFilters.city.value.value;
            // if(this.cityFilterCount === 0){
            //   this.count = 1;
            //   this.cityFilterCount = 1;
            // }

            if (this.$refs.vehiclesTable) {
                this.$refs.vehiclesTable.refresh()
            }
        }
        if (this.$route.params.status === "Active") {
            this.onSelectStatus();
        }
    }
};
</script>

<style>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    background: #FFFFFF;
    border: 2px solid #E0E0E0;
    border-radius: 6px;
}

.gradientbt {
    background: #35A2FE;
    color: white;
    /* background: #35A2FE;
    box-shadow: 0px 0px 4px rgba(15, 105, 64, 0.25);
    border-radius: 4px; */
}

/* new css */

.toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #CCCCCC;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #35A2FE;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.active_wrp a {
    flex: 0 0 30%;
    color: #35A2FE;
    margin-right: 10px;
}

.datedrop_boxs_wrapper {
    position: relative;
    z-index: 2;
}

.datedrop_boxs_inner {
    position: absolute;
    right: 185px;
    top: 5px;
}

.datedrop_boxs_inner_survey {
    right: 85px !important;
}

.datedrop_boxs_inner button {
    background: #35A2FE;
    /* color: #fff; */
    border: 0;
    padding: 5px 20px;
    border-radius: 5px;
}

.datedrop_boxs_inner_survey button {
    padding: 6px 20px !important;
    width: max-content;
    margin-right: 65px;
}

.filter_wrpp1 {
    margin-right: 47px;
    margin-top: 11px;
}

.datedrop_boxs_inner_survey {
    top: 10px !important;
}

.datedrop_rel_inner .d-flex {
    background: #fff;
    padding: 10px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.flex {
    display: flex;
}

.multiselected {
    min-width: 145px;
    max-width: 146px;
}

/* .flex {
      display: flex;
    } */

.selectwca_wrp .multiselect__tags {
    min-height: 26px;
    display: block;
    padding: 4px 35px 0px 7px;
    border-radius: 5px;
    border: 1px solid #35A2FE;
    background: #fff;
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.selectwca_wrp .multiselect__select:before {
    top: 50%;
}

.selectwca_wrp .multiselect__tag {
    padding: 4px 15px 4px 10px;
}

.selectwca_wrp .multiselected {
    min-width: 160px;
}

.selectwca_wrp .multiselect__tags-wrap {
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
    max-height: 70px;
    position: absolute;
    top: 35px;
    left: 0;
    padding: 10px 10px 0px;
}

.selectwca_wrp .multiselect__tags-wrap::-webkit-scrollbar {
    width: 5px;
}

.selectwca_wrp .multiselect__tags-wrap::-webkit-scrollbar-thumb {
    background: #888;
}

.main_select_wrp_relative .modal-dialog {
    width: 57% !important;
}

.main_select_wrp_relative {
    position: absolute;
    right: 30%;
    top: 25px;
}

.filter_wrpp button svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.filter_wrpp button {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.filter_wrpp button:hover {
    background: #35A2FE;
    color: #fff;
}

.main_select_wrp_relative+.add-item {
    display: flex;
}

.main_select_wrp_vechile .selectwca_wrp .multiselected {
    min-width: 50.5%;
}

/* .fa .fa-edit {
        position: absolute;
        width: 34px;
        height: 34px;
        left: 1787px;
        top: 396px;
    
        background: #35A2FE;
        border-radius: 4px;
    
    } */
.common_save_btn {
    position: absolute;
    top: -45px;
}

.curser_pointer {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// vehicles.vue?908ed76a